import React from "react";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";

const SaveButton = ({
  onClick,
  name = "Save",
  icon = <SaveIcon />,
  sx = {},
  ...props
}) => (
  <Button
    variant="contained"
    onClick={onClick}
    startIcon={icon || undefined}
    sx={{
      background: "#02462E",
      width: 160,
      height: 50,
      borderRadius: "10px",
      color: "#fff",
      textTransform: "none",
      "&:hover": {
        background: "#FEC700",
        color: "#02462E",
      },
      ...sx,
    }}
    {...props}
  >
    {name}
  </Button>
);

export default SaveButton;
